import React from 'react';
import DeveloperBoard from '@mui/icons-material/DeveloperBoardOutlined';
import { Forecast, ForecastDetails } from '@Pages';

export const modelFactoryPages = [
  {
    title: 'DemandForecast',
    icon: <DeveloperBoard />,
    to: '/demand-forecast',
    render: <Forecast />,
  },
  {
    to: '/demand-forecast/new',
    render: <ForecastDetails />,
  },
  {
    to: '/demand-forecast/search_job/:searchId',
    render: <ForecastDetails />,
  },
];
